<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-codigo">
                <label class="label-caption">Boleto</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.numeroboleto) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Emissão</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtemissao) }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Nosso Número</label>
                <div class="field-label field-label-center">{{ objView.nossonumero }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ objView.nmpessoa }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-number">
                <label class="label-caption">Valor</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlboleto) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Vencimento</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvencimento) }}</div>
            </div>

            <div class="form-item-number">
                <label class="label-caption">Valor Recebido</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objView.vlrecebido) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Recebimento</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtpagamento) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Cancelamento</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtexclusao) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Situação</label>
                <div class="field-label">{{ objView.situacaonm }}</div>
            </div>
        </div>

        <div v-if="!showCancelamento" class="row-end">
            <button v-if="objView.titulo_confirmado==='S'" @click="emitirBoleto">Imprimir Boleto</button>
            <button v-if="objView.titulo_confirmado==='S' && !objView.dtexclusao" @click="showCancelamento=true">Cancelamento</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>


    <div v-if="showCancelamento" class="form-edit-page">
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Justificativa</label>
                <input type="text" v-model="edInfoCancelamento" maxlength="100" v-uppercase />
            </div>
        </div>
        <div class="row-end">
            <button class="btn-confirm" @click="salvarCancelamento()">Confirmar</button>
            <button @click="showCancelamento=false">Voltar</button>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, getBoletoPdf } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const emitSave= ref(false);
const edInfoCancelamento= ref(null);
const errorMessage = ref(null);
const isLoading = ref(false);
const objView = ref({});
const showCancelamento = ref(false);

const closeForm = () => {
    emit('close'); 
    if (emitSave.value){emit('save')}
}

const emitirBoleto = async() => {
    try{
        isLoading.value=true;
        errorMessage.value=null;
        const response = await getBoletoPdf(objView.value.id);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    }catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const lerDados = async() => {
    try{
        errorMessage.value=null;
        isLoading.value = true;
        const req = await genericPost('/cobranca_api/boletos', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
    }catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value = false;}
}

const salvarCancelamento = async()=>{
    try{
        if (!edInfoCancelamento.value) throw new Error('Informe a justificativa');
        isLoading.value=true;
        errorMessage.value=null;
        const r = await genericPost('/cobranca_api/boleto/cancelamento', {
            idmunicipio: globalStore.idmunicipio,
            id: objView.value.id, 
            idlogin: globalStore.idlogin, 
            strparam1: edInfoCancelamento.value,
            idusuario: globalStore.idusuario});
        if (r.bolok==1){
            lerDados();
            emitSave.value=true;
            showCancelamento.value=false;
        }else{throw new Error(r.erro);}
    }catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>